import {getNeighborHexKeys} from "../coords/getNeighborHexKeys";

export const getNeighborUnits = (hexKey, units) => {
  const neighborKeys = getNeighborHexKeys(hexKey);
  return units.filter(otherUnit => neighborKeys.includes(otherUnit.hexKey));
}